'use client';

import { NewLine } from '@/components/Form/Fields';
import FormField from '@/components/Form/FormField';
import FormSection from '@/components/Form/FormSection';
import { isHidden } from '@/components/Form/helper/formHelper';
import classes from '@/components/Form/styles/form.module.scss';
import type { FormPageProps } from '@/components/Form/types';
import HeadlineField from '@/components/customFields/HeadlineField';
import { HeadlineTag } from '@/components/customFields/types';
import { isFormSection } from '@/types/typeguards';
import classNames from 'classnames';
import { type FC } from 'react';

const FormPage: FC<FormPageProps> = ({ pageBlok, index, formValues, embedded = true, form }: FormPageProps) => {
  // Do not render if it is hidden
  if (isHidden(pageBlok, form, formValues)) {
    return null;
  }

  return (
    <>
      {embedded && pageBlok.name && (
        <HeadlineField
          className={classNames('fullWidth', classes.formPageTitle)}
          tag={HeadlineTag.H4}
          style={HeadlineTag.H6}
        >
          {pageBlok.name}
        </HeadlineField>
      )}

      {pageBlok?.content?.map((blok, index) => {
        if (blok.component === 'NewLine') {
          return <NewLine key={pageBlok._uid} />;
        }
        return isFormSection(blok) ? (
          <FormSection
            key={blok._uid || `section-${index}`}
            sectionBlok={blok} // Ensure correct casting
            index={index}
            formValues={formValues}
            form={form}
          />
        ) : (
          <FormField
            key={blok._uid || `field-${index}`}
            fieldBlok={blok}
            index={index}
            formValues={formValues}
            form={form}
          />
        );
      })}
    </>
  );
};

export default FormPage;
